const initialState = {
    states: [],
    statemessages:{}
};

const stateReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_STATE':
            return {
                ...state, states: action.payload.data
            };
            case "ADD_STATE":
              return {
                ...state, statemessages: action.payload.data
            };
            case 'UPDATE_STATE':
              return {
                ...state, statemessages: action.payload.data
            };
          default:
            return state;
    }
}
export default stateReducer;